module.exports = __webpack_public_path__ + "assets/img/delivery.12734dc0.jpg";